import React, { Component } from 'react';
import './App.css';
// import Table from './components/Table/Table';
import Intro from './components/Intro/Intro';
// import Blob from './components/Blob/Blob';
// import Test from './components/Test/Test';
import Cards from './components/Cards/Cards';
import Footer from './components/Footer/Footer';
import Fade from 'react-reveal/Fade';

class App extends Component {

  state = {
    intro: {
      image: './images/UAR2018_presidentRao_180824_022_aj-HDR_v4-Rao_forweb.jpg',
      feature_description: 'What inspires us to do what we do?',
      feature_image: './images/UAR2018_HERO_180824_022_aj-HDR_v4-Rao_forweb.jpg',
      feature_title: 'What inspires us?',
      text: '<div class="Intro-title">A blank canvas.</div><p>To us, this canvas represents the opportunity to dream big. It gives us hope and unites us to make those dreams real. From sparking conversation through contemporary art, to using our ingenuity to design futuristic pods, to innovating medicines for all, we are inspired to fill our canvas with experiences that improve lives, save lives and give life more meaning. Our collection of work reflects, with simplicity and truth, the extraordinary talents of our community. This is what we create together. This is the Virginia Commonwealth University annual report for 2018.</p><br><p>Thank you for your continued support.</p><p><img src="./images/rao-sig_blk.png" alt="Signature of Michael Rao" style="width:256px;" /><br><br>Michael Rao, Ph.D.<br>President, VCU and VCU Health System</p>'
    },
    card: [
      {
        id: 1,
        order: 1,
        aria_label: 'Opening minds through art at the new ICA',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '2x2',
        image: './images/UAR2018_ICA-VCU-18-03-SHA-3677_sr.jpg',
        title: '<div class="width--60 font-weight--700">Opening minds through art at the new ICA</div>',
        blurb_placement: 'top-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-youtube-container"><iframe src="https://www.youtube-nocookie.com/embed/qOJTXq5yl2M" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="modal-content-pad"><h2>Opening minds through art at the new ICA</h2><p>Our newest, most iconic landmark doubles as a work of art and cultural resource for Richmond. The Institute for Contemporary Art at the Markel Center opened in spring 2018 with its first exhibition, “Declaration,” and sparked conversation. The opening attracted more than 7,000 community members to experience how art can be a forum for open dialogue, collaboration and the exchange of perspectives.</p></div>'
      },{
        id: 2,
        order: 2,
        aria_label: 'Advancing bench-to-bedside research',
        type: 'image',
        color: 'white',
        background_color: 'green',
        size: '1x1',
        image: './images/UAR2018_benchtobed_GettyImages-925066994.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Advancing bench-to-bedside research</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>Advancing bench-to-bedside research</h2><div class="modal-content-col--left"><p>We are the only Virginia university to receive the $21.5 million clinical and translational science award from the National Institutes of Health. With it comes our membership to a national consortium of more than 50 research hubs funded by the National Center for Advancing Translational Sciences. Our C. Kenneth and Dianne Wright Center for Clinical and Translational Research will lead efforts to partner across the commonwealth to cultivate and train the interdisciplinary translational science workforce, integrate special and underserved populations in this research, improve quality and efficiency, engage in informatics, and promote community-engaged research.</p></div><div class="modal-content-col--right"><img src="./images/UAR2018_benchtobed_GettyImages-925066994.jpg" alt="Illustration of human brain to represent one of the many research areas involved in clinical and translational science." /></div></div>'
      },{
        id: 3,
        order: 3,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#C3257A',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 4,
        order: 4,
        aria_label: 'Rethinking pain management',
        type: 'image',
        color: 'white',
        background_color: 'green',
        size: '1x1',
        image: './images/pills.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Rethinking pain management</div>',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>Rethinking pain management</h2><div class="modal-content-col--left"><p>We have committed to addressing the national opioid health crisis through research, treatment and education efforts. In 2018, the School of Medicine received accreditation from the Accreditation Council for Graduate Medical Education for its addiction fellowship, which focuses on addiction medicine and includes emphasis on prevention and pain. This accreditation came ahead of Virginia Gov. Ralph Northam’s visit to VCU, where he presented a grand rounds on pain killer prescription practices and pain management.</p></div><div class="modal-content-col--right"><img src="./images/pills.jpg" alt="Pill capsules" /></div></div>'
      },{
        id: 5,
        order: 5,
        aria_label: 'Making it to the SpaceX Hyperloop finals',
        type: 'image',
        color: 'white',
        background_color: 'purple',
        size: '2x2',
        image: './images/UAR2018_Hyperloop_GettyImages-863773008.jpg',
        title: '<div class="width--60 font-weight--700">Making it to the SpaceX Hyperloop finals</div>',
        blurb_placement: 'bottom-right',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-youtube-container"><iframe src="https://www.youtube-nocookie.com/embed/8Q_OWVijJ_o" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="modal-content-pad"><h2>Making it to the SpaceX Hyperloop finals</h2><p>Hyperloop at VCU — a team of about 35 students from engineering, the arts, business, government and humanities and sciences — was one of 20 teams to advance to the final round of the international competition that challenges university teams to design and build the best transport pod for Hyperloop, a high-speed ground transport concept being advanced by SpaceX founder Elon Musk.</p></div>'
      },{
        id: 6,
        order: 6,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#E3A72B',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 7,
        order: 7,
        aria_label: 'Gaining another win against cancer',
        type: 'image',
        color: 'white',
        background_color: 'blue',
        size: '1x1',
        image: './images/UAR2018_MasseyCAR-T_GettyImages-686373144.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Gaining another win against cancer</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-youtube-container"><iframe src="https://www.youtube-nocookie.com/embed/1FkQEPbZBHU" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="modal-content-pad"><h2>Gaining another win against cancer</h2><p>The VCU Massey Cancer Center is the first in Virginia to offer an FDA-approved CAR T-cell therapy. This new type of immunotherapy, called adoptive cell therapy, genetically modifies a patient’s T-cells so they will attack cancer cells. CAR T-cell therapy has proven very effective at treating advanced blood cancers in both children and adults, allowing many patients to avoid a bone marrow transplant.</p></div>'
      },{
        id: 8,
        order: 8,
        aria_label: '$6 billion economic impact on Virginia',
        type: 'image',
        color: 'white',
        background_color: 'red',
        size: '1x1',
        image: './images/UAR2018_ecomonicimpact.jpg',
        title: '<div class="sr-only">$6 billion </div><div class="Card-blurb-title-bg font-size--24">Economic impact on Virginia</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 9,
        order: 9,
        aria_label: '$271 million in sponsored awards',
        type: 'image',
        color: 'white',
        background_color: 'green',
        size: '1x1',
        image: './images/UAR2018_research_160728_511_jr_ar.jpg',
        title: '<div class="sr-only">$271 million </div><div class="Card-blurb-title-bg font-size--24" style="padding-left: 4rem">In sponsored awards</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>$271 million in sponsored awards</h2><div class="modal-content-col--left"><ul><li><strong>$140.9</strong> million federally funded grants</li><li><strong>No. 14</strong> nationally for addiction studies research, National Institutes of Health</li><li><strong>No. 32</strong> nationally for neuroscience research, National Institutes of Health</li><li><strong>134</strong> invention disclosures</li><li><strong>155</strong> patents filed</li><li><strong>30</strong> patents issued</li><li><strong>8</strong> copyrights</li><li><strong>18</strong> licenses/options</li><li><strong>62</strong> industry engagements</li><li><strong>$2.7</strong> million licensing revenues</li><li><strong>$1.6</strong> million proof-of-concept funding</li></ul></div><div class="modal-content-col--right"><img src="./images/UAR2018_research_160728_511_jr_ar.jpg" alt="$271 million in sponsored awards" /></div></div>'
      },{
        id: 10,
        order: 10,
        aria_label: 'Piloting new ways to connect with Richmond',
        type: 'image-content',
        color: '#222',
        background_color: '#fff',
        size: '2x1',
        image: './images/UAR2018_GRTC.jpg',
        title: '<div class="font-size--24 font-weight--700 text-shadow--none no-pill">Piloting new ways to connect with Richmond</div>',
        blurb_placement: 'top-left',
        excerpt: '<p class="line-height--15">Together with Greater Richmond Transportation Company, we are piloting a $1.2 million ridership program to give our students and employees, including VCU Health team members, unlimited access to Richmond’s bus service — and greater access and alternative means to explore and connect to more areas of the city.</p>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 11,
        order: 11,
        aria_label: '31,036 students enrolled',
        type: 'image',
        color: 'white',
        background_color: 'gray',
        size: '1x1',
        image: './images/UAR2018_student-enrollment_GettyImages-917512178.jpg',
        title: '<div class="sr-only font-size--40 font-weight--700">31,036 students</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        // expanded_html: '<div class="modal-content-pad"><h2>2017-18 enrollment facts</h2><ul><li>31,036 students enrolled</li><li>43% minority</li><li>29% underrepresented minority</li><li>85.8% Virginia residents</li><li>82% full time</li><li>22.9% enrolled in STEM</li><li>83% first-year retention rate</li><li>63% six-year graduation rate</li></ul></div>'
        // expanded_html: '<img alt="A" src="./images/UAR2018_student-enrollment_GettyImages-917512178.jpg" /><div class="modal-content-pad"><h2>2017-18 enrollment facts</h2><ul><li>31,036 students enrolled</li><li>43% minority</li><li>29% underrepresented minority</li><li>85.8% Virginia residents</li><li>82% full time</li><li>22.9% enrolled in STEM</li><li>83% first-year retention rate</li><li>63% six-year graduation rate</li></ul></div>'
        expanded_html: '<div class="modal-content-pad"><h2>2017-18 enrollment facts</h2><div class="modal-content-col--left"><ul><li><strong>31,036</strong> students enrolled</li><li><strong>43%</strong> minority</li><li><strong>29%</strong> underrepresented minority</li><li><strong>85.8%</strong> Virginia residents</li><li><strong>82%</strong> full time</li><li><strong>22.9%</strong> enrolled in STEM</li><li><strong>84.7%</strong> first-year retention rate</li><li><strong>67.4%</strong> six-year graduation rate</li></ul></div><div class="modal-content-col--right"><img src="./images/UAR2018_student-enrollment_GettyImages-917512178.jpg" alt="31,036 students enrolled" /></div></div>'
      },{
        id: 12,
        order: 12,
        aria_label: 'Connecting more students to science',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_connectingmore_GettyImages-801700784.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Connecting more students to science</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>Connecting more students to science</h2><div class="modal-content-col--left"><p>We are among 33 colleges and universities selected by the Howard Hughes Medical Institute to participate in its 2018 Inclusive Excellence initiative, which aims to help schools find ways to engage more students in science ­­­— especially those from underrepresented groups, such as minorities, first-generation students, and working adults with families. More than 7,000 students — the majority of which will be transfer students — and 75 faculty members from VCU and John Tyler and Reynolds community colleges will benefit from the $1 million grant over five years.</p></div><div class="modal-content-col--right"><img alt="Researcher in lab" src="./images/UAR2018_connectingmore_GettyImages-801700784.jpg" /></div></div>'
      },{
        id: 13,
        order: 13,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#264170',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 14,
        order: 14,
        aria_label: '137,678 hours of student service',
        type: 'image',
        color: 'white',
        background_color: 'skyblue',
        size: '1x1',
        image: './images/UAR2018_Communityservice-hours.jpg',
        title: '<div class="sr-only">137,678 </div><div class="Card-blurb-title-bg font-size--24" style="margin-top: 3rem;">Hours of student service</div>',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 15,
        order: 15,
        aria_label: 'More room, more views for first years',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '2x2',
        image: './images/180809_525_aj_sr_coverup.jpg',
        title: '<div class="font-size--24m-48t font-weight--700 text-shadow--none z-index--1"><span class="display--block">More room, more</span> <span class="display--block">views for first</span> <span class="display--block">years</span></div><div class="Card-triangle--top-right"></div>',
        blurb_placement: 'top-right',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-youtube-container"><iframe src="https://www.youtube-nocookie.com/embed/DRNiYTDusgc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="modal-content-pad"><h2>More room, more views for first years</h2><p>A $96 million residential life project transformed a three-story dormitory into the 12-story, 360,000-square-foot Gladding Residence Center, now home to 1,524 first-year students.</p></div>'
      },{
        id: 16,
        order: 16,
        aria_label: 'Recognizing our breadth and scope',
        type: 'image-content',
        color: '#222',
        background_color: '#fff',
        size: '2x1',
        image: './images/UAR2018_Schoolstocolleges_080716_053_tk_ar.jpg',
        title: '<div class="font-size--24 font-weight--700 text-shadow--none no-pill">Recognizing our breadth and scope</div>',
        blurb_placement: 'top-left',
        excerpt: '<p class="line-height--15">The School of Allied Health Professions is now the College of Health Professions, and the School of Engineering is now the College of Engineering. The new names reflect the expanding breadth and level of academic programming, as well as each college’s increase in research, faculty and student enrollment.</p>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 17,
        order: 17,
        aria_label: '2,338 teaching and research faculty',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_Totalfaculty_GettyImages-801700784.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Teaching and research faculty</div>',
        blurb_placement: 'bottom-center',
        excerpt: '<div class="sr-only">2,338</div>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 18,
        order: 18,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#C65221',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 19,
        order: 19,
        aria_label: '$634.4 million raised since Make It Real Campaign for VCU began in 2012',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_campaign.jpg',
        title: '<div class="sr-only">$634.4 million </div><div class="Card-blurb-title-bg font-size--24 font-weight--700">Funds raised since the Make It Real Campaign for VCU began in 2012 (fiscal year end June 30, 2018)</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 20,
        order: 20,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#722F7E',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 21,
        order: 21,
        aria_label: 'GPAs soar, student-athletes score awards',
        type: 'image',
        color: 'white',
        background_color: 'skyblue',
        size: '2x2',
        image: './images/UAR2018_Athletics_McCormick-Taylor_sr.jpg',
        title: '<div class="font-size--24m-44t font-weight--700 width--50">GPAs soar, student-athletes score awards</div>',
        blurb_placement: 'top-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>GPAs soar, student-athletes score awards</h2><div class="modal-content-col--left"><ul><li><strong>73%</strong> earned 3.0 or above for spring 2018</li><li><strong>62%</strong> earned 3.0 or above for fall 2017</li><li><strong>5</strong> conference tournaments</li><li><strong>1</strong> regular season title</li><li><strong>5</strong> national academic team awards</li><li><strong>3</strong> All-American athletes</li></ul></div><div class="modal-content-col--right"><img alt="Woman in V-C-U track and field uniform performing long jump." src="./images/UAR2018_Athletics_McCormick-Taylor_sr.jpg" /></div></div>'
      },{
        id: 22,
        order: 22,
        aria_label: '22,888 total employees, VCU and VCU Health System',
        type: 'image',
        color: 'white',
        background_color: 'gold',
        size: '1x1',
        image: './images/UAR2018_totalemployees_GettyImages-921375446.jpg',
        title: '<div class="sr-only">22,888 </div><div class="Card-blurb-title-bg font-size--24 font-weight--700">Total employees, VCU and VCU Health System</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 23,
        order: 23,
        aria_label: 'Achieving the most improved graduation rates',
        type: 'image-content',
        color: '#222',
        background_color: '#fff',
        size: '2x1',
        image: './images/UAR2018_closingthegap_180424_066_km_sr.jpg',
        title: '<div class="font-size--24 font-weight--700 text-shadow--none no-pill">Achieving the most improved graduation rates</div>',
        blurb_placement: 'top-left',
        excerpt: '<p class="line-height--15">In a seven-year span guided by our strategic plan, we increased the overall four-year graduation rate from 34 percent to 44.4 percent, and the six-year graduation rate from 57 percent to 67.4 percent. These increases were the highest among major public research institutions in Virginia, and our students from underrepresented groups experienced the most dramatic increase in graduation rates.</p>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 24,
        order: 24,
        aria_label: 'Increasing access to Medicines for All',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_medicineforall_train.jpg',
        title: '<div class="Card-blurb-title-bg font-size--24 font-weight--700">Increasing access to Medicines for All</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-youtube-container"><iframe src="https://www.youtube-nocookie.com/embed/6-IxNhhrQsA" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><div class="modal-content-pad"><h2>Increasing access to Medicines for All</h2><p>The Bill & Melinda Gates Foundation awarded the College of Engineering a $25 million grant to establish the Medicines for All Institute and to help increase access — through pharmaceutical engineering — to lifesaving medications for HIV/AIDS, malaria, tuberculosis and other diseases around the world.</p></div>'
      },{
        id: 25,
        order: 25,
        aria_label: 'Creating makerspace and collaboration hubs',
        type: 'image-content',
        color: '#222',
        background_color: '#fff',
        size: '2x1',
        image: './images/UARR2018_EGR-Buildingmakerspace_180510-VCU-ERB-_View-from-Cary-St.jpg',
        title: '<div class="font-size--24 font-weight--700 text-shadow--none no-pill">Creating makerspace and collaboration hubs</div>',
        blurb_placement: 'top-left',
        excerpt: '<p class="line-height--15">We broke ground on a $93 million, 133,000-square-foot research building that will significantly expand the College of Engineering’s laboratory capacity and will serve as a hub for students and faculty to advance research and economic development efforts. The facility’s design emphasizes makerspaces, collaborative research and flexible gathering areas.</p>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 26,
        order: 26,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#C3257A',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 27,
        order: 27,
        aria_label: 'Top 50 programs, U.S. News & World Report',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_Newsworldreport_GettyImages-546439334.jpg',
        title: '<div class="sr-only"><span class="display--block" style="margin-left: -1rem;">top</span><span class="display--block font-size--96">50</span></div>',
        blurb_placement: 'bottom-center',
        excerpt: '<div class="sr-only">Top 50 programs </div><div class="Card-blurb-title-bg font-size--24 font-weight--700 text-shadow--black" style="margin-bottom: 1rem;"><span class="display--block font-size--32 text-shadow--none">U.S. News & World Report</span></div>',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>U.S. News & World Report rankings</h2><div class="display--inline-block width--66"><div class="modal-content-col--left"><ul style="margin-bottom: 0; margin-top: 0;"><li><strong>1st</strong> Fine arts — sculpture</li><li><strong>1st</strong> Nurse anesthesia</li><li><strong>2nd</strong> Fine arts</li><li><strong>3rd</strong> Fine arts — glass</li><li><strong>3rd</strong> Health care management</li><li><strong>4th</strong> Rehabilitation counseling</li><li><strong>7th</strong> Fine arts — graphic design</li><li><strong>7th</strong> Fine arts — painting/drawing</li><li><strong>9th</strong> Fine arts — ceramics</li><li><strong>10th</strong> Fine arts — printmaking</li></ul></div><div class="display--inline-block width--50"><ul style="margin-top: 0;"><li><strong>17th</strong> Occupational therapy</li><li><strong>17th</strong> Pharmacy</li><li><strong>20th</strong> Physical therapy</li><li><strong>24th</strong> Nuclear engineering</li><li><strong>26th</strong> Best Education Schools</li><li><strong>30th</strong> Social work</li><li><strong>41st</strong> Best Nursing Schools: Master’s</li><li><strong>44th</strong> Public affairs</li><li><strong>48th</strong> Best Nursing Schools: Doctor of Nursing Practice</li></ul></div></div><div class="display--inline-block width--34 vertical-align--top" style="padding-left: 1rem;"><img src="./images/UAR2018_Newsworldreport_GettyImages-546439334.jpg" alt="Top 50 programs, U.S. News & World Report" /></div></div>'
      },{
        id: 28,
        order: 28,
        aria_label: '193,724 total living alumni',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_totalofalumni_GettyImages-523169768.jpg',
        title: '<div class="sr-only">193,724 </div><div class="Card-blurb-title-bg font-size--24 font-weight--700">Total living alumni</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 29,
        order: 29,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#e3a72b',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 30,
        order: 30,
        aria_label: '',
        type: 'color',
        color: 'white',
        background_color: '#264170',
        size: '1x1',
        image: '',
        title: '',
        blurb_placement: 'center-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 31,
        order: 32,
        aria_label: '$4.3B revenues and capital additions, $3.9B expenditures, total for VCU, VCU Health System and affiliated foundations (2016-17)',
        type: 'image',
        color: 'white',
        background_color: 'green',
        size: '1x1',
        image: './images/UAR2018_Revenue.jpg',
        title: '<div class="Card-blurb-title-bg font-size--20 font-weight--700">Total for VCU, VCU Health System and affiliated foundations (2016-17)</div>',
        blurb_placement: 'bottom-center',
        excerpt: '<div class="sr-only"><div style="padding-bottom: 1em;"><div class="font-size--24 font-weight--700">$4.3B </div>Revenues and capital additions</div><div><div class="font-size--24 font-weight--700">$3.9B </div>Expenditures</div></div>',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 32,
        order: 31,
        aria_label: '7,588 degrees and certificates awarded',
        type: 'image',
        color: 'white',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_grads.jpg',
        title: '<div class="sr-only">7,588 </div><div class="Card-blurb-title-bg font-size--24 font-weight--700">Degrees and certificates awarded</div>',
        blurb_placement: 'bottom-center',
        excerpt: '',
        open_status: false,
        has_expanded_html: true,
        expanded_html: '<div class="modal-content-pad"><h2>7,588 degrees and certificates awarded</h2><div class="modal-content-col--left"><ul><li><strong>5,082</strong> baccalaureate</li><li><strong>1,420</strong> master’s</li><li><strong>326</strong> doctorate</li><li><strong>444</strong> first professional</li><li><strong>102</strong> undergraduate post-baccalaureate certificate</li><li><strong>189</strong> graduate post-baccalaureate certificate</li><li><strong>25</strong> graduate post-master’s</li></ul></div><div class="modal-content-col--right"><img alt="7,588 degrees and certificates awarded" src="./images/UAR2018_grads.jpg" /></div></div>'
      }
    ],
    people: [
      {
        id: 101,
        order: 1,
        aria_label: 'Beth Angell, Ph.D.',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_Beth_Angell_180911_005_aj_sr.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">Beth Angell, Ph.D., dean, School of Social Work</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 102,
        order: 2,
        aria_label: 'Karol Kain Gray',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_Karol_Gray_180911_007_aj_sr.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">Karol Kain Gray, senior vice president and CFO</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 103,
        order: 3,
        aria_label: 'Mike Melis, J.D.',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_Mike_Melis_180911_010_aj_sr.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">Mike Melis, J.D., University Counsel</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 104,
        order: 4,
        aria_label: 'Aashir Nasim, Ph.D.',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_Aashir-Nasim_180911_002_aj_sr.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">Aashir Nasim, Ph.D., vice president, Inclusive Excellence</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 105,
        order: 5,
        aria_label: 'P. Srirama Rao, Ph.D.',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_PSrirama_Rao_180911_016_aj_sr_.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">P. Srirama Rao, Ph.D., vice president, Research and Innovation</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },{
        id: 106,
        order: 6,
        aria_label: 'Constance Relihan, Ph.D.',
        type: 'image',
        color: '#fff',
        background_color: '#fff',
        size: '1x1',
        image: './images/UAR2018_murals_Constance_Relihan_180911_009_aj_sr.jpg',
        title: '<div class="font-size--16m-24t font-weight--700">Constance Relihan, Ph.D., dean, University College</div>',
        blurb_placement: 'bottom-left',
        excerpt: '',
        open_status: false,
        has_expanded_html: false,
        expanded_html: ''
      },
    ]
  };

  render() {
    const intro = this.state.intro;
    const cardData = this.state.card;
    const peopleData = this.state.people;

    return (
      <div className="App">
        <div className="container">
          <Intro
            introData={ intro }
          />
          <Cards
            cardData= { cardData }
          />
          <Fade bottom ssrFadeout delay={ 500 * Math.random() }>
            <div className="Card-group-separator">
              <div className="Card-group-separator-container">
                <div className="font-size--36 font-weight--700">New talent</div>
              </div>
            </div>
          </Fade>
          <Cards
            cardData= { peopleData }
          />
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js